import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  ModalProps,
} from '@chakra-ui/react';
import styled from 'styled-components';

export const CloseButton = styled.button`
  position: absolute;
  top: 17px;
  right: 17px;
  width: 16px;
  height: 16px;

  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const CustomHeader = styled(ModalHeader)`
  display: flex;
  align-items: center;
  margin-bottom: 17px;
`;

export const IconArea = styled.div`
  margin-right: 11px;
  display: flex;
`;

export const HeaderTitle = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
`;
